/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
import { Redirect, Switch } from 'react-router';
// material
import { SubDivision } from '@insticator/insticator-ui'; // iui-material
import ImageSelector from 'pages/dashboard/embeds/management/customize/imageselector/imageselector_container';
import StepIndicator from 'material/embeds/steps/stepindicator/stepindicator_container';
// // pages
import PlacementPage from 'pages/dashboard/embeds/management/placement/placement_container';
import CustomizePage from 'pages/dashboard/embeds/management/customize/customize_container';
import AdsPage from 'pages/dashboard/embeds/management/ads/ads_container';
import AddOnsPage from 'pages/dashboard/embeds/management/addons/addons_container';
import CodePage from 'pages/dashboard/embeds/management/code/code_container';
// utils
import { formDataBlob } from 'utils/transpilers/embedbackendsettings';
import { PrivateRoute, browserAlertOn, browserAlertOff } from '@insticator/insticator-ui'; // iui-material
// // styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/embed_management_styles';



/* ========== ~~~~~~~~~~ EMBED MANAGEMENT ~~~~~~~~~~ ========== */
class EmbedManagement extends Component {
    constructor(props) {
        super(props)
    }
    componentDidMount() {
        // Show an alert if user tries to navigate off the embed management page
        if(this.props.isNewEmbedFlow) this.turnEditStateAlertsOn();

        // Handle using browser's Back and Forward buttons to navigate.
        window.addEventListener('popstate', this.handleBrowserNavButtons);
    }
    componentDidUpdate(prevProps) {
        // For the edit embed mode show browser alerts only if user made any changes
        if(this.changeMade(prevProps)) this.turnEditStateAlertsOn();
        if(this.changeProcessed(prevProps)) this.turnEditStateAlertsOff();
    }
    componentWillUnmount() {
        // ensure alerts are off when user moves off the embed management flow
        // we also disable alerts once the new embed is created
        this.turnEditStateAlertsOff();

        // this.props.resetEmbedAndContentState();
        window.removeEventListener('popstate', this.handleBrowserNavButtons);
    }
    handleSaveEmbed = () => {
        const siteUUID = this.props.selectedEmbedStatus.selectedEmbedData.siteUUID;
        const selectedEmbedData = this.props.selectedEmbedStatus.selectedEmbedData;
        const contents = this.props.contentStatus.contents;
        //handle save addons
        const addons = this.props.contentStatus.addons;
        const updatedContents = this.props.contentStatus.updatedContents;
        if (this.props.embedUUID) {
            this.props.updateEmbed(siteUUID, this.props.embedUUID, formDataBlob(selectedEmbedData, contents, addons, updatedContents, this.props.executorUUID, this.props.currentStepPage))
        } else {
            this.props.createEmbed(siteUUID, formDataBlob(selectedEmbedData, contents, addons, updatedContents, this.props.executorUUID, this.props.currentStepPage));
        }
    };
    handleBrowserNavButtons = () => {
        const step = /[^/]*$/.exec(document.location.pathname)[0];
        // Redirect to the library if user navigates off the code page using browser Back or Forward Buttons (create embed flow only).
        if(this.isNewEmbedCodePage()) this.props.moveToLibrary();
        // Update currentStepPage in the embedManagementStatus when user uses browser's Back and Forward buttons to navigate.
        this.props.updateStepDetails(step);
    };
    turnEditStateAlertsOn = () => {
        // Show a browser alert if user uses browser navigation to leave the embed management workflow
        browserAlertOn();
        // Set the editMode in the appStatus to true.
        // This will enable the modal to alert user if they try to navigate off the management page.
        this.props.setEditMode(true);
    };
    turnEditStateAlertsOff = () => {
        browserAlertOff();
        this.props.setEditMode(false);
    };
    changeMade = prevProps => !this.props.isNewEmbedFlow && this.props.changeDetected && !prevProps.changeDetected;
    changeProcessed = prevProps => !this.props.isNewEmbedFlow && !this.props.changeDetected && prevProps.changeDetected;
    isNewEmbedCodePage = () => this.props.isNewEmbedFlow && this.props.currentStepPage === 'code';
    render() {
        return (
            <Switch>
                <SubDivision name={`embedManagement`} klass={`${this.props.classes.embedManagement} imageSelectorActive-${this.props.currentStepPage === 'customize'} isSavingData-${this.props.isSavingData}`}>
                    <div id={`main`}>
                        <StepIndicator /> {/* steps built off store object, and this component KNOWs whether to display itself or not for certain pages */}
                        <div id={`wrapper`}>
                            {this.props.currentStepPage === 'customize' ? <ImageSelector /> : null}
                            <Switch>
                                <PrivateRoute permitted={this.props.isDataReceived} exact path='/dashboard/embeds/management/placement' redirectTo='/dashboard/embeds/' handleSaveEmbed={this.handleSaveEmbed} component={PlacementPage} />
                                <PrivateRoute permitted={this.props.isDataReceived} exact path='/dashboard/embeds/management/customize' redirectTo='/dashboard/embeds/' handleSaveEmbed={this.handleSaveEmbed} component={CustomizePage} />
                                <PrivateRoute permitted={this.props.isDataReceived} exact path='/dashboard/embeds/management/ads' redirectTo='/dashboard/embeds/' handleSaveEmbed={this.handleSaveEmbed} component={AdsPage} />
                                <PrivateRoute permitted={this.props.isDataReceived} exact path='/dashboard/embeds/management/add_ons' redirectTo='/dashboard/embeds/' handleSaveEmbed={this.handleSaveEmbed} component={AddOnsPage} />
                                <PrivateRoute permitted={this.props.isDataReceived} exact path='/dashboard/embeds/management/code' redirectTo='/dashboard/embeds/' handleSaveEmbed={this.handleSaveEmbed} component={CodePage} />
                                <Redirect to='/error/404' />
                            </Switch>
                        </div>
                    </div>
                </SubDivision>
            </Switch>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedManagement);
